/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>发票</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.machineNo" placeholder="商家名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.orderNo" placeholder="订单id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.transId" placeholder="商家id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="orderId" label="id" width="200" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mchName" label="餐厅名称" width="240" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="entName" label="企业名称" width="240" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="payerNickname" label="申请人" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="amount" label="订单金额" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="cash" label="发票金额" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.distVersion == 1">{{scope.row.cash}}</div>
          <div v-if="scope.row.distVersion == 2 ">{{scope.row.coupon}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="goodsPrice" label="结算方式" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.distVersion == 1">现结模式</div>
          <div v-if="scope.row.distVersion == 2 ">预存模式</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="申请时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.updateTime * 1000|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">

          <el-upload class="upload-demo" action="http://39.107.109.196:14400/file/restaurant/ossUploadFile"
            :data="{ id: scope.row.orderId, picType: 2 ,path:'qicanhui/'}" name="imgFile" :show-file-list="false"
            :on-success="handleEdit" multiple :limit="1">
            <el-button size="small" type="primary">上传发票</el-button>
            <!-- <el-button size="mini" type="danger" @click="handleEdit(scope.$index, scope.row)"></el-button> -->
          </el-upload>



          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    OrderList,
    uploadInvoice
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: localStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          machineNo: '',
          orderNo: '',
          transId: '',
          payType: 0,
          orderStatus: 0,
          token: localStorage.getItem('logintoken')
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        },
        xzddid: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    created() {
      this.getdata(this.formInline)
    },


    methods: {
      // 获取公司列表
      getdata(parameter) {
        let pro = {
          "baseInfo": {
            "pageNum": parameter.page,
            "pageSize": parameter.limit
          },

          "data": {
            mch_id: parameter.transId,
            is_invoice: "1",
            mch_name: parameter.machineNo,
            order_id: parameter.orderNo,
            payType: '1',
            cityId: localStorage.getItem('cityId1'),
            start_date: "",
            end_date: ""
          }
        }
        OrderList(pro)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.baseInfo.message
              })
            } else {
              this.listData = res.data.records
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //shangchuan
      handleEdit(response, file, fileList, tupe) {
        console.log(response, file, fileList, tupe)
        let taht = this
        if (response.code == 0) {
          let pro = {
            "data": {
              "orderId": response.data.id,
              "path": response.data.fileName
            }
          }
          uploadInvoice(pro).then(res => {
            taht.getdata(taht.formInline)
          })
        }
      },
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/pay/Config.vue